//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import {
  FACEBOOK_MAX_IMAGE_FILE_SIZE_MB,
  FACEBOOK_MAX_VIDEO_DURATION_MINUTES,
} from '@facebook/constants/facebookConstants';

export const SHORTLINK_TOOLTIP_MESSSAGE_REVENUE =
  'To get revenue data for this post, shorten your shoppable links.';

export const SHORTLINK_MODAL_MESSAGE_REVENUE =
  'Shorten your shoppable links to get revenue data for this post.';

export const SHORTLINK_MODAL_MESSAGE_DEFAULT =
  "Add your link into the field below, and we'll generate a short link for you.";

export const FacebookPostDetailsFormFieldErrorText = {
  ImageTooLarge: (
    errorImageCountString: string,
    largeImageCount: number,
  ) => `${errorImageCountString} image${largeImageCount > 1 ? 's' : ''} you are 
    scheduling ${largeImageCount > 1 ? 'are' : 'is'} larger than Facebook's
    recommended file size of ${FACEBOOK_MAX_IMAGE_FILE_SIZE_MB} MB and may
    fail at post time. Please consider uploading a smaller version of this
    content.`,
  NoMediaOrLink: 'Please add either media or a link to this post.',
  NoPostTime: 'Please select a time to schedule this post.',
  OriginalScheduledTimeInPast:
    "Changes cannot be saved, please review this post's status on the Schedule Calendar.",
  PostTimeInPast:
    'Please select a post time in the future to schedule this post.',
  VideoTooLong: `The video you selected is longer than Facebook’s 
    ${FACEBOOK_MAX_VIDEO_DURATION_MINUTES} minute limit. Please try 
    scheduling a shorter version of this video or posting directly on 
    Facebook.com.`,
} as const;
